<template>
  <footer class="bg-red-claro flex flex-col h-auto p-3 sm:p-6 gap-2 items-center text-center">
    <img
      class="w-10"
      importance="high"
      src="https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png"
      alt="Claro Controle"
    />

    <p class="mdn-Text mdn-Text--caption mdn-Text--inverse flex flex-row gap-2">
      <a
        class="cms-Link gtm-element-event mdn-Footer-disclaimer-link"
        title="Acessar Política de Privacidade"
        target="_self"
        href="https://www.claro.com.br/privacidade/politica-de-privacidade"
        data-gtm-event-action="clique:footer"
        data-gtm-event-category="claro:portal:/"
        data-gtm-event-label="politica-de-privacidade"
        >Política de Privacidade</a
      ><a
        class="cms-Link gtm-element-event mdn-Footer-disclaimer-link"
        title="Acessar Portal de Privacidade"
        target="_self"
        href="https://www.claro.com.br/privacidade"
        data-gtm-event-action="clique:footer"
        data-gtm-event-category="claro:portal:/"
        data-gtm-event-label="portal-de-privacidade"
        >Portal de Privacidade</a
      >
    </p>
    <p class="mdn-Text mdn-Text--caption mdn-Text--inverse"><strong>© {{ new Date().getFullYear() }} Claro. Todos os direitos reservados. CNPJ: 40.432.544/0001-47 - Rua Henri Dunant, 780 - São Paulo - SP</strong></p>
    <p class="mdn-Text mdn-Text--caption mdn-Text--inverse text-opacity-25">v{{ version }}</p>

  </footer>
</template>

<script>
import { version } from '../../package.json'
export default {
  name: 'app-footer',
  data () {
    return {
      version
    }
  },
  mounted () {
    this.$tracker.log('debug:backend_url', process.env.VUE_APP_AUTOSERVICO_API)
  }
}
</script>
